import $ from "jquery";
import anime from "animejs";

// export var currentScene = 0;
// export var level = 0
// export var visitedScene = new Array();


export default {
    GetAnchorPosition(anchor) {
        //   alert("bar")
        // console.log($(".scene-wrap").height())
        var height = $(".scene-wrap").height()
        var width = $(".scene-wrap").width()
        var top = $(anchor).css("top").slice(0, -2) / height * 100 + "%";
        var left = $(anchor).css("left").slice(0, -2) / width * 100 + "%";
        // console.log("anchor top: "+$(anchor).css("top").slice(0, -2) )
        // console.log("anchor height: "+ height)
        return [top, left];
    },
    AnimeToAnchor(target, anchor) {
        var anchor_tl = anime.timeline({
            // easing: "easeOutExpo",
            autoplay: false,
            // loop: true,
            // delay: 5000,
            begin: function (anim) {
                console.log("anchor_tl began : " + anim.began);
            }.bind(this)
            // complete: function (anim) {
            //     // console.log("complete : " + anim.began);fa
            // }
        });
        // console.log(anchor)
        var height = $(".scene-wrap").height()
        var width = $(".scene-wrap").width()
        var targetTop = $(target).css("top").slice(0, -2) / height * 100 + "%";
        var targetLeft = $(target).css("left").slice(0, -2) / width * 100 + "%";
        $(anchor).each(function () {

            var top = $(this).css("top").slice(0, -2) / height * 100 + "%";
            var left = $(this).css("left").slice(0, -2) / width * 100 + "%";
            var newScale = 1;
            var level = parseFloat(top);
            if (level < 30) {
                newScale = 0.6;
            } else if (level < 60) {
                newScale = 0.8
            }
            // console.log("new scale: " + Number(newScale)+" level: "+level)

            anchor_tl.add({
                duration: 1500,
                targets: target,
                top: [targetTop, top],
                left: [targetLeft, left],
                scale: parseFloat(newScale),
                // scale: [1,1.1, 1],
                elasticity: 1000,
                easing: "linear",
                // direction: "alternate",
            });


            targetTop = top;
            targetLeft = left;
        });
        anchor_tl.restart();
    },
    ConvertScene(number) {
        var scene;
        switch (number) {
            case 0, "0":
                scene = "1";
                break;
            case 1, "1":
                scene = "2a";
                break;
            case 2, "2":
                scene = "2b";
                break;
            case 3, "3":
                scene = "3a";
                break;
            case 4, "4":
                scene = "3b";
                break;
            default:
                scene = "1";
                break;
        }
        console.log("[convert]number: " + number);
        console.log("[convert]scene: " + scene);
        return scene;
    }
}